import { AppGql, AppStatus, TokeetEnvironment } from '@papi/interfaces'

export const appSchema = `{
  _id
  partnerId
  name
  imgId
  privacy
  terms
  secret
  status
  environment
  readmeUrl
  deletion {
    type
    url
    name
    email
    address
  }
  redirectUrls
  webhookUrl
}`

export interface UsersPartnerApp
  extends Pick<
    AppGql,
    | '_id'
    | 'partnerId'
    | 'name'
    | 'imgId'
    | 'terms'
    | 'privacy'
    | 'deletion'
    | 'security'
    | 'redirectUrls'
    | 'secret'
    | 'status'
    | 'environment'
    | 'readmeUrl'
    | 'webhookUrl'
  > {
  status: AppStatus
  environment: TokeetEnvironment
}
